<button (click)="onClick()" [ngClass]="{'button-hidden': hidden}"><i [hidden]="hidden" class="icon-arrow_back_header"></i></button>
